import React from 'react'
import Yup from '../../../../../helpers/custom-yup'
import Title from '../../../../../components/typography/title.component'
import Button from '../../../../../components/buttons/buttons.component'
import DatepickerInput from '../../../../../components/form-components/datepicker-input.component'
import InnerPageContainer from '../../../../../components/layout/private/inner-page-container.component'
import PaginationComponent from '../../../../../components/pagination/pagination.component'
import StyledInputContainer from '../../../../../components/form-components/styled-input-container.component'
import { MuvicardAdminService } from '../../../../../services/muvicard-admin.service'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { maskHelper } from './../../../../../helpers/mask.helper'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../../actions'
import { bindActionCreators } from 'redux'
import { AdminReportsService } from './../../../../../services/admin-reports.service'
import { cardProposalsReportActions } from './card-proposals-report.actions'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { StyledForm, StyledSectionHeader } from './styles.style'
import {
	CPFInput,
	NumberInput,
	SelectInput,
	TextInput
} from '../../../../../components/form-components/inputs.component'
import ModalConfirmation from '../../../../../components/modal/modal-confirmation.component'

class CardProposalsReportPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.isExporting = false
		this.initialValues = {
			name: '',
			moveflexNumber: '',
			cpf: '',
			cardProposalNumber: '',
			cardStatus: '',
			proposalStatus: '',
			proposalDate: null
		}
		this.schema = Yup.object().shape({
			name: Yup.string(),
			moveflexNumber: Yup.number().positive(),
			cpf: Yup.string(),
			cardStatus: Yup.string(),
			proposalStatus: Yup.string(),
			cardProposalNumber: Yup.string()
		})
		this.state = {
			params: {},
			modalText: '',
			modalIsOpen: false,
			modalButtonEnabled: false,
			modalProposalId: ''
		}
	}

	componentDidMount() {
		onSubmit.call(this, this.initialValues)
	}

	render() {
		const { modalIsOpen, modalButtonEnabled, modalText } = this.state
		return (
			<InnerPageContainer>
				<Title>Solicitações de cartões</Title>
				<StyledSectionHeader>Filtros</StyledSectionHeader>
				<Formik
					initialValues={this.initialValues}
					onSubmit={onSubmit.bind(this)}
					validationSchema={this.schema}
					ref={'form'}
					render={props => (
						<StyledForm noValidate onSubmit={props.handleSubmit}>
							<div className="col1">
								<StyledInputContainer
									style={{ gridColumn: '1 / span 2' }}>
									<TextInput id="name" label="Nome" {...props} />
								</StyledInputContainer>
								<StyledInputContainer>
									<NumberInput
										id="moveflexNumber"
										label="Número Muviflex"
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<CPFInput id="cpf" label="CPF" {...props} />
								</StyledInputContainer>
							</div>
							<div className="col2">
								<StyledInputContainer
									style={{ gridColumn: '1 / span 2' }}>
									<TextInput
										id="cardProposalNumber"
										label="Número da proposta do cartão"
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<SelectInput
										id="proposalStatus"
										name="proposalStatus"
										label="Situação da proposta"
										placeholder="Todos"
										defaultValue={{
											value: '',
											label: 'Todos'
										}}
										options={[
											{ label: 'Todos', value: '' },
											{ label: 'Aprovados', value: 'Aprovado' },
											{ label: 'Negados', value: 'Negado' }
										]}
										multi={false}
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<SelectInput
										id="cardStatus"
										name="cardStatus"
										label="Situação do cartão"
										placeholder="Todos"
										defaultValue={{
											value: '',
											label: 'Todos'
										}}
										options={[
											{ label: 'Todos', value: '' },
											{ label: 'Ativo', value: 'Ativo' },
											{ label: 'Cancelado', value: 'Cancelado' },
											{ label: 'Bloqueado', value: 'Bloqueado' },
											{ label: 'Inativo', value: 'Inativo' }
										]}
										multi={false}
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<DatepickerInput
										showClearDate
										id="proposalDate" //dateStart
										label="Data da Solicitação"
										{...props}
									/>
								</StyledInputContainer>
							</div>
							<div
								style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<Button data-permission="34DD61D03056C463F16D6583E9442B2563764D20"
									secondary
									style={{ marginRight: '15px' }}
									type="button"
									onClick={exportData.bind(this)}>
									Exportar
								</Button>
								<Button primary type="submit" data-permission="75297A4E1BE9AC5AC2F621280B2BA297137052B5">
									Consultar
								</Button>
							</div>
						</StyledForm>
					)}
				/>
				<div style={{ marginTop: '20px', width: '100%' }} data-permission="75297A4E1BE9AC5AC2F621280B2BA297137052B5">
					<PaginationComponent
						ref="pagination"
						rowsPerPage={100}
						params={this.state.params}
						getData={AdminReportsService.searchCardProposals}
						headers={[
							{
								header: 'Data Solicitação',
								key: 'proposalDate',
								align: 'center'
							},
							{ header: 'Proposta', key: 'cardProposalNumber' },
							{ header: 'Situação Proposta', key: 'proposalStatus' },
							{ header: 'Situação Cartão', key: 'cardStatus' },
							{ header: 'Nome', key: 'name' },
							{
								header: 'Número Muviflex',
								key: 'moveflexNumber',
								align: 'center'
							},
							{ header: 'CPF', key: 'cpf' },
							{ header: 'RG', key: 'rg' },
							{ header: 'E-mail', key: 'email' },
							{ header: 'Telefone', key: 'phone' },
							{ header: 'Email 2º Fator', key: 'emailTwoFactorStatus' },
							{ header: 'SMS 2º Fator', key: 'smsTwoFactorStatus' },
							{ header: 'Regras de validação', key: 'validationRules' }
						]}
						sortable={{
							defaultOrder: 'desc',
							cols: [
								{ key: 'proposalDate' },
								{ key: 'proposalStatus' },
								{ key: 'cardStatus' },
								{ key: 'cardProposalNumber' },
								{ key: 'name' },
								{ key: 'moveflexNumber' },
								{ key: 'cpf' },
								{ key: 'rg' },
								{ key: 'email' },
								{ key: 'phone' },
								{ key: 'emailTwoFactorStatus' },
								{ key: 'smsTwoFactorStatus' },
								{ key: 'validationRules' }
							]
						}}
						renderRow={(rowData, headers) => {
							return headers.map(({ key, align }) => (
								<td key={key} align={align}
									onClick={() => {
										this.handleRowClicked(
											rowData.proposalStatus,
											rowData.name,
											rowData.cardProposalNumber
										)
									}}
								>
									<span title={rowData[key]}>
										{key == 'cpf'
											? maskHelper.applyCpf(rowData[key])
											: rowData[key]}
									</span>
								</td>
							))
						}}
					/>
				</div>
				<div>
					<ModalConfirmation
						OnlyNoButton={!modalButtonEnabled}
						isOpen={modalIsOpen}
						buttonNoText={'Voltar'}
						buttonYesText={
							modalButtonEnabled ? 'Aprovar proposta' : 'Continuar'
						}
						onResult={this.onResult}
						title={`Proposta ${this.state.modalProposalId}`}>
						{modalText}
					</ModalConfirmation>
				</div>
			</InnerPageContainer>
		)
	}


	onResult = confirmed => {
		const { modalButtonEnabled, modalProposalId, params } = this.state
		if (confirmed && modalButtonEnabled && !!modalProposalId) {
			MuvicardAdminService.approveManualProposal(modalProposalId)
				.then(
					setTimeout(() => {
						this.setState({ params }, () => this.refs.pagination.reload())
					})
				)
		}
		this.setState({
			modalIsOpen: false,
			modalButtonEnabled: false,
			modalText: '',
			modalProposalId: ''
		})
	}

	handleRowClicked = (status, name, id) => {
		const buttonEnabled = status === "Negado"
		this.setState({
			modalIsOpen: true,
			modalButtonEnabled: !!buttonEnabled,
			modalText: buttonEnabled ? `Proposta Muvicard negada de ${name}. Confirmar aprovação?` : 'Esse status não permite aprovação de proposta manual.',
			modalProposalId: id
		})
	}
}

function onSubmit(values) {
	const { exportData } = this.props

	const params = Object.assign({}, values)
	if (this.isExporting) {
		this.isExporting = false
		exportData(params)
	} else {
		this.setState({ params }, () => this.refs.pagination.reload())
	}
}

function exportData() {
	this.isExporting = true
	this.refs.form.submitForm()
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
			...cardProposalsReportActions
		},
		dispatch
	)

const connectedCardProposalsReportPageComponent = withRouter(
	connect(null, mapDispatchToProps)(CardProposalsReportPageComponent)
)

export { connectedCardProposalsReportPageComponent as ModuleRootComponent }
